import { useState } from "react";
import { Box, IconButton, Tooltip, CircularProgress } from "@mui/material";
import { AddRounded } from "@mui/icons-material";
import axios from "axios";
import { useSnackbar } from "notistack";
import { withPather } from "react-pather";
import TagModal from "./TagModal";

const TagCreationButton = ({ pather, onSuccess }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const createTag = (name, color) => {
    setOpen(false);
    setLoading(true);
    axios
      .post(pather.back.tags, {
        name,
        color,
      })
      .then((response) => {
        const data = response.data;
        const tag = data.tag;
        onSuccess(tag);
      })
      .catch((error) => {
        console.log(error);
        const status = error?.response?.data?.status;
        if (status) enqueueSnackbar(status, { variant: "error" });
        else
          enqueueSnackbar("Error occurred during tag creation", {
            variant: "error",
          });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {loading ? (
        <CircularProgress size={30} />
      ) : (
        <Box>
          <Tooltip title="Add new tag" arrow>
            <IconButton onClick={() => setOpen(true)}>
              <AddRounded />
            </IconButton>
          </Tooltip>
        </Box>
      )}
      {open && (
        <TagModal
          open={open}
          setOpen={setOpen}
          title="Tag Creation"
          confirm={createTag}
        />
      )}
    </>
  );
};

export default withPather()(TagCreationButton);
